
















import { Component, Emit, Ref, Vue, Watch } from 'vue-property-decorator';
import { CustomException } from '@tencent/ppd-base-libs';
import HeaderTab from './header-tab.vue';
import BottomTab from './bottom-tab.vue';
import { BottomTabType, HeaderTabType, isHeaderTabPage } from '@/config/page-tab';
import { getUserPrizeTabInfo } from '@/business/red-dot';
import { Route } from 'vue-router';

type RedDotInfo = {
  [HeaderTabType.couponlist]: boolean;
  [HeaderTabType.displaycouponlist]: boolean;
};

type CountInfo = {
  [HeaderTabType.couponlist]: number | undefined;
  [HeaderTabType.displaycouponlist]: number | undefined;
};

@Component({
	  components: {
	    HeaderTab,
	  	BottomTab,
	  },
})
export default class PageTab extends Vue {
  @Ref('headerTab') readonly headerTab!: HeaderTab;
  private redDotInfo: RedDotInfo = {
	  [HeaderTabType.couponlist]: false,
	  [HeaderTabType.displaycouponlist]: false,
  };
  /** 未拿到时保持 undefined，HeaderTab 据此降级为不带数量括号的纯名称 */
  private countInfo: CountInfo = {
    [HeaderTabType.couponlist]: undefined,
	  [HeaderTabType.displaycouponlist]: undefined,
  };
  private isShowBottomRedDot = false;

  @Watch('$route')
  private onRouteChanged(to: Route, from: Route) {
    // 仅从非 Tab 页跳入时刷新，Tab 间互切不重拉
    if (isHeaderTabPage(to) && !isHeaderTabPage(from)) {
      this.initData();
    }
  }

  private	async created() {
    await this.initData();
  }

  private async initData() {
    try {
      const prizeTabInfo = await getUserPrizeTabInfo();
      Object.keys(prizeTabInfo).forEach((tab) => {
        this.redDotInfo[tab] = prizeTabInfo[tab].hasRedDot;
        this.countInfo[tab] = prizeTabInfo[tab].count;
      });
      this.isShowBottomRedDot = this.calcBottomRedDot();
      this.headerTab.updateCurrentRouteRedDot();
    } catch (e) {
      // 不兜底 countInfo（保持 undefined 让 HeaderTab 降级），仅上报异常
      new CustomException(e, 'initPageTabFail', '优惠专区 PageTab 初始化数量/红点失败');
    }
  }

  private handleRedDotInfoUpdate() {
	  // 只有header-tab的红点展示完时，才主动取消bottm-tab的红点，其余情况由bottom-tab自己控制
	  const allHasRedDot = this.calcBottomRedDot();
	  if (!allHasRedDot) {
	    this.isShowBottomRedDot = false;
	  }
  }

  private calcBottomRedDot() {
	  return this.redDotInfo[HeaderTabType.couponlist]
		 || this.redDotInfo[HeaderTabType.displaycouponlist];
  }

  @Emit('clearRedDot')
  private clearRedDot({ tab, key }: {tab: 'header'|'bottom', key: string}) {
	  if (tab === 'bottom' && key === BottomTabType.couponlist) {
	    this.isShowBottomRedDot = false;
	    return;
	  }
		 if (tab === 'header') {
			 if (!this.redDotInfo[key]) {
				 return;
			 }
	    this.redDotInfo[key] = false;
	    this.handleRedDotInfoUpdate();
	  }
  }
}
